

const statUnits =[
  { id: '1', name: "Imperial/Metric", value: "AL" },
  { id: '2', name: "Metric", value: "CM" },
  { id: '3', name: "Imperial", value: "IN"}
];

export default statUnits;




// WEBPACK FOOTER //
// ./src/data/stat-units.js